import store2 from 'store2'

import { StorageType } from '../typings/storage'

export const storage: StorageType = store2
